/**
 * BirthDataForm Component Styles
 */

.container {
  padding: var(--spacing-lg);
  max-width: 500px;
  margin: 0 auto;
  width: 100%;
}

.title {
  font-size: var(--font-size-xxl);
  text-align: center;
  margin-bottom: var(--spacing-xs);
}

.subtitle {
  text-align: center;
  color: var(--tg-theme-hint-color);
  margin-bottom: var(--spacing-xl);
}

.form {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-lg);
}

.field {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-sm);
}

.label {
  font-size: var(--font-size-sm);
  font-weight: 600;
  color: var(--tg-theme-text-color);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.input {
  padding: var(--spacing-md);
  font-size: var(--font-size-lg);
  border-radius: var(--border-radius);
  background-color: var(--tg-theme-secondary-bg-color);
  color: var(--tg-theme-text-color);
  border: none;
  outline: none;
  transition: box-shadow var(--transition-fast);
}

.input:focus {
  box-shadow: 0 0 0 2px var(--tg-theme-button-color);
}

.input::placeholder {
  color: var(--tg-theme-hint-color);
}

/* Date and time inputs on iOS need special styling */
.input[type="date"],
.input[type="time"] {
  appearance: none;
  -webkit-appearance: none;
  min-height: 48px;
}

.hint {
  font-size: var(--font-size-sm);
  color: var(--tg-theme-hint-color);
}

.warning {
  font-size: var(--font-size-sm);
  color: var(--tg-theme-destructive-text-color);
  background-color: rgba(255, 59, 48, 0.1);
  padding: var(--spacing-sm) var(--spacing-md);
  border-radius: var(--border-radius-sm);
}

.unknownTime {
  padding: var(--spacing-md);
  font-size: var(--font-size-lg);
  border-radius: var(--border-radius);
  background-color: var(--tg-theme-secondary-bg-color);
  color: var(--tg-theme-hint-color);
  text-align: center;
}

.toggleButton {
  padding: var(--spacing-sm) var(--spacing-md);
  font-size: var(--font-size-sm);
  color: var(--tg-theme-link-color);
  background: transparent;
  border: none;
  cursor: pointer;
  text-align: left;
}

.toggleButton:hover {
  text-decoration: underline;
}

.selectedLocation {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--spacing-md);
  font-size: var(--font-size-lg);
  border-radius: var(--border-radius);
  background-color: var(--tg-theme-secondary-bg-color);
}

.clearButton {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: var(--tg-theme-hint-color);
  color: var(--tg-theme-bg-color);
  font-size: var(--font-size-sm);
  cursor: pointer;
  opacity: 0.5;
  transition: opacity var(--transition-fast);
}

.clearButton:hover {
  opacity: 1;
}

.locationList {
  list-style: none;
  padding: 0;
  margin: 0;
  background-color: var(--tg-theme-section-bg-color);
  border-radius: var(--border-radius);
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.locationItem {
  width: 100%;
  padding: var(--spacing-md);
  text-align: left;
  font-size: var(--font-size-md);
  background: transparent;
  color: var(--tg-theme-text-color);
  border: none;
  border-bottom: 1px solid var(--tg-theme-secondary-bg-color);
  cursor: pointer;
  transition: background-color var(--transition-fast);
}

.locationItem:last-child {
  border-bottom: none;
}

.locationItem:hover {
  background-color: var(--tg-theme-secondary-bg-color);
}

.locationItem:active {
  background-color: var(--tg-theme-button-color);
  color: var(--tg-theme-button-text-color);
}
